import type { FunctionComponent, HTMLProps } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './Hr.module.scss'

/**
 * Primary Hr component between two paragraphs inside a container div.
 * Hr will inherit width of the parent div component.
 */

export const Hr: FunctionComponent<Props> = ({
  className,
  fullWidth,
  ...rest
}) => (
  <hr
    className={classnames(
      styles.hr,
      {
        [styles.hrFullWidith]: fullWidth,
      },
      className
    )}
    {...rest}
  />
)

///////// IMPLEMENTATION /////////

type Props = {
  className?: string
  fullWidth?: boolean
} & HTMLProps<HTMLHRElement>
